export default __webpack_public_path__ + "static/media/6t.3c5695a5.jpg";